import React, { useState, useEffect, useMemo } from 'react';
import VistaprintAuth from '@vp/auth';
import { hasValidCanonicalId } from './utils';
import { cimpressInternalClaim, customerClaim, canonicalIDClaim } from './constants';
export function redirectAfterSignOut() {
    return window.location.href;
}
export const getVpAuthInitOptions = (clientId, isProd, isCareAgent, connection, redirectUriOrigin) => {
    if (isCareAgent) {
        return {
            options: {
                connection: 'vistaprintcom-waad',
                redirectAfterSignOutCallback: redirectAfterSignOut,
                clientID: 'tCZE1T00Yk6Uqs4jLO0HtpwLopz8BN7F',
            },
        };
    }
    if (!isProd) {
        const authInit = {
            options: {
                redirectAfterSignOutCallback: redirectAfterSignOut,
            },
            developmentMode: {
                clientID: clientId,
                redirectUriOrigin: redirectUriOrigin || `${window.location.origin}/auth-callback/`,
            },
        };
        if (connection) {
            // @ts-ignore
            authInit.options.connection = connection;
        }
        return authInit;
    }
    return {
        developmentMode: false,
    };
};
export const IdentityContext = React.createContext(undefined);
export const IdentityProvider = (props) => {
    const { connection, children, locale, isProd, isCareAgent, ownerId, clientId = 'Yu3FHXEddNJchTpznXGYnEEbnubgOuGi', redirectUriOrigin, } = props;
    const [auth, setAuth] = useState();
    const [isIdentityInitialized, setIsIdentityInitialized] = useState(false);
    const [identity, setIdentity] = useState();
    useEffect(() => {
        const options = getVpAuthInitOptions(clientId, isProd, isCareAgent, connection, redirectUriOrigin);
        if (locale) {
            VistaprintAuth.init(Object.assign({ culture: locale }, options), () => {
                const initialAuth = new VistaprintAuth.WebAuth();
                setAuth(initialAuth);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locale]);
    useEffect(() => {
        if (!auth)
            return;
        setIdentity(auth.getIdentity());
        auth.onUserIdentityUpdate((newIdentity) => {
            if (!newIdentity) {
                return;
            }
            // Special rules if we are trying to access studio as a care agent
            if (isCareAgent && newIdentity) {
                // if we are not logged in, then force user to log in
                if (!newIdentity.isSignedIn) {
                    // eslint-disable-next-line consistent-return
                    return auth && auth.signIn();
                }
                // if we are logged in, but we are not logged in using cimpress ADFS, force user to log in by logging out first
                // internal users are fine
                const cimpressInternal = newIdentity.profile && newIdentity.profile[cimpressInternalClaim];
                // new logic to support agents at external organizations
                // make sure they're not a customer and that they have the correct tenants
                const validCanonicalId = newIdentity.profile && hasValidCanonicalId(newIdentity.profile[canonicalIDClaim]);
                const isCustomer = newIdentity.profile && newIdentity.profile[customerClaim];
                const careAgentLoggedIn = (validCanonicalId && !isCustomer) || cimpressInternal;
                if (!careAgentLoggedIn) {
                    // eslint-disable-next-line consistent-return
                    return auth && auth.signOut();
                }
            }
            setIsIdentityInitialized(true);
            setIdentity(newIdentity);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth]);
    const value = useMemo(() => ({ isIdentityInitialized, ownerId, identity, auth, shouldBeCareAgent: isCareAgent }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isIdentityInitialized, identity, ownerId, isCareAgent]);
    return React.createElement(IdentityContext.Provider, { value: value }, children);
};
IdentityProvider.displayName = 'IdentityProvider';
//# sourceMappingURL=IdentityProvider.js.map